import Vue from 'vue'
import App from './App.vue'
//import AppUpload from './AppUpload.vue'
import vuetify from './plugins/vuetify';
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import store from './store'
import router from './router'
import config from './config/config'
import  Sortable  from  'sortablejs'
import VueClipboard from 'vue-clipboard2'



Vue.config.productionTip = false
process.env.LOCATION = location.host;

Vue.directive(
    'sortableDataTable',{
        bind: function (el, binding, vnode) {
            const options = {
                animation: 150,
                onUpdate: function (event) {
                  vnode.child.$emit('sorted', event)
                }
              }
              Sortable.create(el.getElementsByTagName('tbody')[0], options)
        }
    }
)

Vue.use(VueClipboard)

console.log(`Is Live Upload = ${config.isCom2usUpload}`);

new Vue({ 
    vuetify, 
    router, 
    store, 
    render: h => h(!config.isCom2usUpload ? App : AppUpload),
}).$mount('#app')